/**
 * @author      patrick@zumper.com (Patrick Giddings)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { combineReducers, createSlice } from '@reduxjs/toolkit'
import { createTypedPayloadReducer } from '@zcode-ui/web-zumper-features'
import type { RentResearchHomepage } from '@zcode/state-type'
import {
  RENT_RESEARCH_HOMEPAGE_INITIAL_STATE,
  RENT_RESEARCH_HOMEPAGE_SLICE_NAME,
} from './constants'

const rentalDataSlice = createSlice({
  name: `${RENT_RESEARCH_HOMEPAGE_SLICE_NAME}/rentalData`,
  initialState: RENT_RESEARCH_HOMEPAGE_INITIAL_STATE.rentalData,
  reducers: {
    receiveRentResearchHomepageRentalData:
      createTypedPayloadReducer<RentResearchHomepage['rentalData']>(),
  },
})

const linkpacksSlice = createSlice({
  name: `${RENT_RESEARCH_HOMEPAGE_SLICE_NAME}/linkpacks`,
  initialState: RENT_RESEARCH_HOMEPAGE_INITIAL_STATE.linkpacks,
  reducers: {
    receiveRentResearchHomepageLinkpacks:
      createTypedPayloadReducer<RentResearchHomepage['linkpacks']>(),
  },
})

export const rentResearchHomepageSlice = {
  name: `${RENT_RESEARCH_HOMEPAGE_SLICE_NAME}`,
  reducer: combineReducers({
    rentalData: rentalDataSlice.reducer,
    linkpacks: linkpacksSlice.reducer,
  }),
  actions: {
    ...rentalDataSlice.actions,
    ...linkpacksSlice.actions,
  },
}

export const { receiveRentResearchHomepageRentalData, receiveRentResearchHomepageLinkpacks } =
  rentResearchHomepageSlice.actions
